var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('baidu-map',{staticClass:"map",attrs:{"center":_vm.center,"zoom":_vm.zoom,"scroll-wheel-zoom":false},on:{"ready":_vm.handler}},[_c('bm-navigation',{attrs:{"anchor":"BMAP_ANCHOR_TOP_RIGHT"}}),_vm._v(" "),_c('bm-overview-map',{attrs:{"anchor":"BMAP_ANCHOR_BOTTOM_RIGHT","isOpen":true}}),_vm._v(" "),_c('bm-marker',{attrs:{"position":{ lng: _vm.center.lng, lat: _vm.center.lat },"icon":{
        url: _vm.markerImg,
        size: { width: 150, height: 150 }
      }}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0351118c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about/components/baiduMap.vue
// module id = null
// module chunks = 